import { render, staticRenderFns } from "./GridColumnIcon.vue?vue&type=template&id=b8927ede&"
import script from "./GridColumnIcon.vue?vue&type=script&lang=js&"
export * from "./GridColumnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports